// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"86dd3f10","453":"9f1d6a0c","732":"2931a986","977":"51b44c23"}[chunkId] + ".chunk.js";
};